import {
  accentLightColor,
  blueStrongShade,
  challanSvgDeleteFill,
  cloudyIndigoColor,
  darkRed,
  emeraldGreen,
  emeraldGreenPaleBg,
  fadeBlueWhite,
  grayShadeWithSoftBlue,
  lightBlueShade,
  lightRedPaleBg,
  lightRedShade,
  outletInvoicingCardShadow,
  outletInvoicingDialogShadow,
  outletInvoicingFocusRingShadow,
  outletInvoicingSelectedGradientStart,
  outletInvoicingSelectedRingShadow,
  outletInvoicingShadowColor,
  outletInvoicingWhiteMuted,
  redShadeStrong,
  slateBorderHoverColor,
  slatePaleBg,
  slightBlueishWhite,
  slightOrange,
  slightRed,
  strongBlue,
  systemColor,
  tagRedBgColor,
  textMutedSubtitleColor,
  textPrimaryColor,
  white,
  whiteBlueShade,
  whiteShadeColor,
  yellowishWhiteColor,
} from "../../../config/ColorObj";

const STYLE_ELEMENT_ID = "advance-outlet-invoicing-color-vars";

/** CSS custom properties sourced from ColorObj — consumed by advanceOutletInvoicing.css */
const CSS_VARIABLES = {
  "--aoi-border": fadeBlueWhite,
  "--aoi-white": white,
  "--aoi-shadow-sm": outletInvoicingShadowColor,
  "--aoi-surface": whiteShadeColor,
  "--aoi-surface-pale": slatePaleBg,
  "--aoi-text-primary": textPrimaryColor,
  "--aoi-info-bg": whiteBlueShade,
  "--aoi-info-text": strongBlue,
  "--aoi-danger-bg": lightRedShade,
  "--aoi-danger-text": darkRed,
  "--aoi-scrollbar": slateBorderHoverColor,
  "--aoi-primary": systemColor,
  "--aoi-primary-light-bg": accentLightColor,
  "--aoi-text-body": textMutedSubtitleColor,
  "--aoi-selected-bg": slightBlueishWhite,
  "--aoi-danger-row-bg": lightRedPaleBg,
  "--aoi-danger": slightRed,
  "--aoi-warning": slightOrange,
  "--aoi-border-strong": grayShadeWithSoftBlue,
  "--aoi-focus": blueStrongShade,
  "--aoi-focus-ring": outletInvoicingFocusRingShadow,
  "--aoi-text-muted": cloudyIndigoColor,
  "--aoi-surface-tint": yellowishWhiteColor,
  "--aoi-dialog-shadow": outletInvoicingDialogShadow,
  "--aoi-warning-bg": lightBlueShade,
  "--aoi-danger-border": challanSvgDeleteFill,
  "--aoi-danger-strong": redShadeStrong,
  "--aoi-card-shadow": outletInvoicingCardShadow,
  "--aoi-success": emeraldGreen,
  "--aoi-success-bg": emeraldGreenPaleBg,
  "--aoi-white-muted": outletInvoicingWhiteMuted,
  "--aoi-selected-start": outletInvoicingSelectedGradientStart,
  "--aoi-selected-ring": outletInvoicingSelectedRingShadow,
  "--aoi-warning-panel-start": tagRedBgColor,
  "--aoi-warning-panel-end": lightRedPaleBg,
};

const buildCssVariablesBlock = () =>
  Object.entries(CSS_VARIABLES)
    .map(([name, value]) => `  ${name}: ${value};`)
    .join("\n");

export const injectAdvanceOutletInvoicingColorVars = () => {
  if (document.getElementById(STYLE_ELEMENT_ID)) {
    return;
  }

  const styleElement = document.createElement("style");
  styleElement.id = STYLE_ELEMENT_ID;
  styleElement.textContent = `:root {\n${buildCssVariablesBlock()}\n}`;
  document.head.appendChild(styleElement);
};

injectAdvanceOutletInvoicingColorVars();
